(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-notification"] && !Shopify.designMode) return;
  try {
    (function () {
  var scheduled = false;

  function positionNotificationRewards() {
    scheduled = false;
    var notification = document.getElementById('cart-notification');
    if (!notification) return;
    var form = notification.querySelector('#cart-notification-form');
    if (!form) return;
    notification.querySelectorAll('.honeypop-cp').forEach(function (widget) {
      if (form.nextElementSibling !== widget) form.after(widget);
    });
  }

  function schedulePosition() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(positionNotificationRewards);
  }

  function init() {
    positionNotificationRewards();
    new MutationObserver(function (records) {
      if (records.some(function (record) {
        return record.addedNodes.length || record.removedNodes.length;
      })) schedulePosition();
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedulePosition);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
